import { ReactNode } from 'react'

export type ContainerProps = {
  $hasChildren?: boolean
  $size: number
  $variant: BadgeProps['variant']
  $backgroundColor?: string
  $textColor?: string
}

export enum BadgeVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  ACCENT = 'accent',
  TAG = 'tag',
  VEHICLE = 'vehicle',
}

export type BadgeProps = {
  children?: ReactNode | string
  minSize?: number
  variant?: BadgeVariant
  backgroundColor?: string
  textColor?: string
  onClick?: (e: React.MouseEvent) => void
}
